import { Copy, Mail, Share2, X } from 'lucide-react'
import { useState } from 'react'
import type { Post } from '../../services/socialApi'

interface ShareModalProps {
  post: Post
  onClose: () => void
}

export default function ShareModal({ post, onClose }: ShareModalProps) {
  const [copied, setCopied] = useState(false)

  const postUrl = `${window.location.origin}/social/post/${post.id}`
  const postTitle = post.content.substring(0, 100)

  const handleCopyLink = () => {
    void navigator.clipboard.writeText(postUrl)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  const handleTwitterShare = () => {
    const text = `${postTitle}... - RunAI.live`
    const url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(postUrl)}`
    window.open(url, '_blank')
  }

  const handleLinkedInShare = () => {
    const url = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(postUrl)}`
    window.open(url, '_blank')
  }

  const handleEmailShare = () => {
    const subject = `Check out this post on RunAI.live`
    const body = `${postTitle}...\n\n${postUrl}`
    window.location.href = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`
  }

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    }} onClick={onClose}>
      <div style={{
        background: 'var(--card-bg)',
        borderRadius: '12px',
        padding: '24px',
        width: '90%',
        maxWidth: '500px',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)'
      }} onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: '20px'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <Share2 size={20} color="var(--text-primary)" />
            <h3 style={{ margin: 0, color: 'var(--text-primary)', fontSize: '18px' }}>Paylaş</h3>
          </div>
          <button onClick={onClose} style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: '4px',
            display: 'flex',
            alignItems: 'center'
          }}>
            <X size={20} color="var(--text-secondary)" />
          </button>
        </div>

        {/* Share Options */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {/* Copy Link */}
          <button onClick={handleCopyLink} style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            padding: '12px 16px',
            background: copied ? 'var(--success-bg)' : 'var(--hover-bg)',
            border: '1px solid var(--border-color)',
            borderRadius: '8px',
            cursor: 'pointer',
            transition: 'all 0.2s'
          }}>
            <Copy size={20} color={copied ? 'var(--success-color)' : 'var(--text-primary)'} />
            <span style={{
              color: copied ? 'var(--success-color)' : 'var(--text-primary)',
              fontSize: '14px',
              fontWeight: '500'
            }}>
              {copied ? 'Link kopyalandı!' : 'Linki kopyala'}
            </span>
          </button>

          {/* Twitter */}
          <button onClick={handleTwitterShare} style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            padding: '12px 16px',
            background: 'var(--hover-bg)',
            border: '1px solid var(--border-color)',
            borderRadius: '8px',
            cursor: 'pointer',
            transition: 'all 0.2s'
          }}>
            <div style={{
              width: '20px',
              height: '20px',
              background: '#1DA1F2',
              borderRadius: '4px'
            }} />
            <span style={{ color: 'var(--text-primary)', fontSize: '14px', fontWeight: '500' }}>
              Twitter&apos;da paylaş
            </span>
          </button>

          {/* LinkedIn */}
          <button onClick={handleLinkedInShare} style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            padding: '12px 16px',
            background: 'var(--hover-bg)',
            border: '1px solid var(--border-color)',
            borderRadius: '8px',
            cursor: 'pointer',
            transition: 'all 0.2s'
          }}>
            <div style={{
              width: '20px',
              height: '20px',
              background: '#0A66C2',
              borderRadius: '4px'
            }} />
            <span style={{ color: 'var(--text-primary)', fontSize: '14px', fontWeight: '500' }}>
              LinkedIn&apos;de paylaş
            </span>
          </button>

          {/* Email */}
          <button onClick={handleEmailShare} style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            padding: '12px 16px',
            background: 'var(--hover-bg)',
            border: '1px solid var(--border-color)',
            borderRadius: '8px',
            cursor: 'pointer',
            transition: 'all 0.2s'
          }}>
            <Mail size={20} color="var(--text-primary)" />
            <span style={{ color: 'var(--text-primary)', fontSize: '14px', fontWeight: '500' }}>
              Email ile gönder
            </span>
          </button>
        </div>
      </div>
    </div>
  )
}
